<template>
  <div class="home" ref="home">
    <!-- <Header :scrollTop="scrollTop" :goodsInfo="goodsInfo" /> -->

    <van-nav-bar
        fixed
        left-arrow
        placeholder
        title="八点秒得"
        @click-left="$router.back()"
    />

    <Banner/>
    <Broadcast/>

    <div class="main-wrap">
      <div class="main-title">今日推荐</div>

      <div class="main-banner">
        <van-swipe :autoplay="5000" indicator-color="#ff991d">
          <van-swipe-item v-for="(image, index) in bannerList" :key="index">
            <img v-lazy="image"/>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="main-info">
        <div class="info-name">
          {{ goodsInfo.goodsName }}
        </div>
        <div class="info-price">
          <span>￥{{ goodsInfo.price }} </span>
          <span> </span>
        </div>
      </div>

      <div class="main-select">
        <div class="select-item">
          <span class="label">规格</span>
          <span class="label">{{ goodsInfo.specStr }}</span>
        </div>
      </div>

      <div class="main-btn">
        <template v-if="!isFinish">
          <div class="btn" v-if="!isTimeOver">
            <span>距离抢购开始</span>
            <van-count-down
                :auto-start="isStart"
                :time="countDownTime"
                format="HH 时 mm 分 ss 秒"
                @finish="onCountDownFinish"
            />
          </div>

          <div
              v-if="isTimeOver && !isGet && !isPayed"
              class="btn"
              @click="onRushBuy"
          >
            抢购
          </div>
          <div
              v-if="isTimeOver && isGet && !isPayed"
              class="btn"
              @click="onOrderPay"
          >
            您有订单暂未支付
          </div>
          <div class="btn" v-if="isTimeOver && isPayed">已秒得</div>
        </template>

        <div class="btn grey" v-if="isFinish">今日活动已结束</div>
      </div>

      <div class="main-goods">
        <div class="goods-text" v-html="goodsInfo.content"></div>
      </div>
    </div>

    <Footer :goodsInfo="goodsInfo"/>
    <OrderForm
        ref="SubmitOrderForm"
        :goodsInfo="goodsInfo"
        :orderId="orderId"
        :timeout="timeout"
    />
  </div>
</template>

<script>
import axios from "axios";
import {debounce} from "lodash";
import {
  doSecKill,
  getSecOrderInfo,
  getRecordList,
  getStartTime,
  getGoodsInfo, getGoodsInfoList,
} from "@/api/home";
import {finishTask} from "@/api/task";

import Header from "./components/Header";
import Banner from "./components/Banner";
import Broadcast from "./components/Broadcast";
import Footer from "./components/Footer.vue";
import OrderForm from "@/components/order-form.vue";
import VConsole from "vconsole";
// ;

export default {
  name: "Home",
  components: {
    Header,
    Banner,
    Broadcast,
    Footer,
    OrderForm,
  },

  data() {
    return {
      scrollTop: 0,
      bannerList: [],
      goodsInfo: {},

      timer: null,
      isTimeOver: false,
      isGet: false,
      isPayed: false,
      isFinish: false,

      countDownTime: 0,
      isStart: false,

      orderId: 0,
      timeout: 0,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //     next((vm) => {
  //         vm.$nextTick(() => {
  //             vm.$refs.home.scrollTop = vm.scrollTop;
  //         });
  //     });
  // },
  // beforeRouteLeave(to, from, next) {
  //     this.scrollTop = this.$refs.home.scrollTop;
  //     next();
  // },
  methods: {

    async finishTask() {
      console.log(this.$store.state.userInfo);
      const {data: res} = await finishTask({
        m2oId: this.$store.state.nthUserInfo.userid,
      });

      console.log(res);

      if (res.code == 200) {
        if (res.data) {
          SmartCity.creditRulesUpdate({
            availableScore: res.data.availableScore,
          });
          this.$toast(res.data.message);
        }

        // this.getFavoriteServeList()
      }
    },
    onCountDownFinish() {
      this.isTimeOver = true;
    },

    onRushBuy() {
      if (this.goodsInfo.linkUrl) {
        SmartCity.linkTo({
          innerLink: this.goodsInfo.linkUrl,
        });

        return;
      }
      // window.location.href ='http://h5.96345.hz66.com/#/&_ddtarget=push'

      this.doSecKill();
    },

    onOrderPay() {
      this.$router.replace("/order");
    },

    init() {
      const isApp = SmartCity.isSmartCityApp();
      if (isApp) {
        this.getNthUserInfo();
      } else {
        // return this.$toast.fail("请在南太湖号App中打开！");

        this.$router.replace("/share");
      }
    },

    getNthUserInfo() {
      this.$toast.loading({
        duration: 0,
        message: "加载中...",
      });
      SmartCity.getUserInfo((res) => {
        if (res && res.userInfo) {
          this.$toast.clear();
          this.$store.commit("setNthUserInfo", res.userInfo);
          this.$store.commit("setUserTokenKey", res.userInfo.userTokenKey);

          this.initOrderData();
          this.finishTask();
        } else {
          this.$toast.clear();
          this.$dialog
              .alert({
                title: "提醒",
                message: "请先登录南太湖号",
              })
              .then(() => {
                this.$router.replace("/error-unlogin");
              });
        }
      });
    },

    async doSecKill() {
      this.$toast.loading({
        duration: 0,
        message: "抢购中...",
      });
      let secKillUrl = process.env.VUE_APP_ROB_URL;


      // let secKillUrl =
      //   process.env.NODE_ENV === "development"
      //     ? "https://flash-sale-backend-test.zhijianmedia.cn/rob/"
      //     : process.env.NODE_ENV === "test"
      //     ? "https://flash-sale-backend-test.zhijianmedia.cn/rob/"
      //     : "https://flash-sale-api.zhijianmedia.cn/rob";

      const {data: res} = await axios.post(
          secKillUrl + "/secKill/doSecKill",
          {
            m2oId: this.$store.state.nthUserInfo.userid,
            token: this.$store.state.token,
          }
      );

      console.log("抢购中", res);
      if (res.code == 200) {
        this.$toast.clear();
        this.$refs.SubmitOrderForm.popupShow = true;
        this.createTimer();
      } else {
        return this.$toast.fail(res.msg);
      }
    },

    async getSecOrderInfo() {
      const {data: res} = await getSecOrderInfo({
        m2oId: this.$store.state.nthUserInfo.userid,
      });

      console.log("订单", res);
      if (res.code == 200) {
        this.orderId = res.data.id;
        this.createTime = res.data.createTime;
        this.timeout = res.data.timeout;
      } else {
        this.$toast.loading({
          duration: 2000,
          message: "订单创建中  ...",
          loadingType: "spinner",
        });
      }
    },

    async getStartTime() {
      const {data: res} = await getStartTime();
      if (res.code == 200) {
        let date = res.data.replace(/-/g, "/");
        this.countDownTime = Date.parse(new Date(date)) - new Date().getTime();
        this.isStart = true;
      }
    },

    async getGoodsInfoList(goodId) {
      const {data: res} = await getGoodsInfoList(goodId)
      this.goodsInfo = {...res.data[0]}
      this.bannerList = res.data.bannerList.split("|") || [];

    },
    async getGoodsInfo() {
      const {data: res} = await getGoodsInfo();
      if (res.code == 200) {
        this.goodsInfo = res.data;

        this.bannerList = res.data.bannerList ? res.data.bannerList.split("|") : [];

      }

      console.log(res, "------goodsInfo");
    },

    async initOrderData() {
      const {data: res} = await getSecOrderInfo({
        m2oId: this.$store.state.nthUserInfo.userid,
      });

      console.log("首次查询订单", res);
      if (res.code == 200) {
        this.orderId = res.data.id;
        this.timeout = res.data.timeout;

        this.isGet = true;
      } else {
        if (res.code == 200005) {
          this.isPayed = true;
        }

        if (res.code == 200102) {
          this.isFinish = true;
        }
      }
    },
    createTimer() {
      this.stopTimer();

      // this.$toast.loading({
      //             duration: 2000,
      //             message: "订单创建中",
      //             loadingType: "spinner",
      //         });

      this.timer = setInterval(async () => {
        const {data: res} = await getSecOrderInfo({
          m2oId: this.$store.state.nthUserInfo.userid,
        });

        console.log("订单", res);

        if (res.code == 200) {
          this.$toast.clear();

          this.orderId = res.data.id;
          this.timeout = res.data.timeout;
          this.stopTimer();
        }

        if (res.code == 200004) {
          this.$toast.loading({
            duration: 2000,
            message: "订单创建中",
            loadingType: "spinner",
          });
        }
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },

  created() {
    const goodId = this.$route.query.goodId
    SmartCity.hideTopView({
      isShow: 0,
    });
    this.getStartTime();
    this.$skillType === 3 ? this.getGoodsInfoList(goodId) : this.getGoodsInfo()

    if (process.env.NODE_ENV === "development") {
      // const vConsole = new VConsole();
      //    return     this.init()

      this.$store.commit("setUserTokenKey", "b819f6472575f02128c5bd851dbfda74");
      this.$store.commit("setNthUserInfo", {
        userid: "1075",
      });

      this.initOrderData();
      this.finishTask();
    } else if (process.env.NODE_ENV === "test") {
      const vConsole = new VConsole();
      this.init();
    } else {
      this.init();
    }
  },
  mounted() {
    this.$refs.home.onscroll = debounce(() => {
      this.scrollTop = this.$refs.home.scrollTop;
    }, 10);
  },
  destroyed() {
    this.stopTimer();
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: calc(100vh);
  overflow-y: scroll;
  padding-bottom: 40px;
  background: #fff;
  // background: #f4f4f4;

  // background: chocolate;

  .main-wrap {
    // z-index: 99;
    margin-top: -10px;
    // position: relative;
    background: #fff;
    border-radius: 10px;

    padding: 15px;
    // box-shadow: @shadow;

    .main-title {
      font-size: 16px;
      padding: 4px;

      color: #ff991d;
    }

    .main-banner {
      width: 100%;
      margin-top: 10px;
      margin-bottom: 10px;

      img {
        border-radius: 10px;
        width: 100%;
        height: 200px;
        // border-radius: 4px;
      }
    }

    .main-info {
      margin-bottom: 10px;

      .info-name {
        font-size: 16px;
        padding: 4px;
      }

      .info-price {
        span:nth-child(1) {
          color: #ff991d;
          font-size: 20px;
        }

        span:nth-child(2) {
          color: #666;
        }
      }
    }

    .main-select {
      margin-bottom: 10px;
      background: #f9f9f9;
      padding: 10px;

      .select-item {
        display: flex;

        justify-content: space-between;
        align-items: center;

        .label {
          color: #666;
        }
      }

      // .select-item:nth-child(1) {
      //   margin-bottom: 15px;
      // }
    }

    .main-btn {
      margin-bottom: 10px;
      padding: 10px;

      .van-count-down {
        color: #fff;
      }

      .btn {
        line-height: 40px;
        position: fixed;
        width: 95%;
        bottom: 20px;
        left: 50%;
        z-index: 1;
        transform: translateX(-50%);

        background: #ff991d;
        border-radius: 20px;

        text-align: center;
        color: #fff;
        display: flex;

        justify-content: center;
        align-items: center;

        span {
          margin-right: 10px;
        }
      }

      .grey {
        background: #ccc;
      }
    }

    .main-goods {
      .goods-text {
        ::v-deep .p {
          ::v-deep img {
            width: 100% !important;
          }
        }

        /deep/ img {
          // border-radius: 10px;
          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }

        /deep/ video {
          // border-radius: 10px;
          margin-top: 10px;

          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }

        margin-bottom: 10px;

        /deep/ p {
          color: #666;

          line-height: 28px;

          // text-indent: 2em;
        }

        P {
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0px;
          margin-inline-end: 0px;
        }
      }

      .goods-img {
        margin: 10px 0;

        img {
          // border-radius: 10px;
          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }

        video {
          // border-radius: 10px;
          margin-top: 10px;

          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }
      }
    }

    .card-header {
      display: flex;

      justify-content: space-between;
      align-items: center;

      .ecard {
        padding: 4px 10px;
        border-radius: 10px 0 0 10px;
        background: #569aff;
        color: #fff;
        margin-right: -10px;
      }

      // flex-direction: column;
    }
  }
}

.grey {
  background: #eee;
}

.home::-webkit-scrollbar {
  display: none;
}
</style>
